import { PlethoraLib, UiData } from "plethora-lib";
import { GeneratedModel } from "./GeneratedClasses/GeneratedModel";
import { Hunter } from "./UiClasses/Hunter";
import { Screen } from "./UiClasses/Screen";
import { Shape } from "./UiClasses/Shape";
import { DataTypeDirection} from "./GeneratedClasses/GeneratedDataTypes" // GENERATED
import { Block } from "./UiClasses/Block";
import { Target } from "./UiClasses/Target";
import { Helper } from "./UiClasses/Helper";
import { Loop } from "./UiClasses/Loop";

export let globals: Record<string, any> = {};

// call when simulation is ready to start communicating with plethora
globals.init = function () {
  PlethoraLib.getInstance().requestInit(new GeneratedModel());
};

// call when an entity is clicked
globals.entityApplyClick = function (entityId: number,clickPlace: UiData) {
  const entityClick = PlethoraLib.getInstance().getModel().getEntity(entityId);  
    if(entityClick instanceof Shape)
    {
      entityClick.applyClick(clickPlace);
    }
    if(entityClick instanceof Hunter)
    {
      entityClick.applyClick(clickPlace)
    }
    if(entityClick instanceof Helper)
    {
      entityClick.applyClick(clickPlace)
    }
    if(entityClick instanceof Target)
    {
      entityClick.applyClick(clickPlace)
    }
    if(entityClick instanceof Block)
    {
      entityClick.applyClick(clickPlace)
    }
};

globals.entityClick = function (entityId: number) {
  const entityClick = PlethoraLib.getInstance().getModel().getEntity(entityId);  
    if(entityClick instanceof Shape)
    {
      entityClick.click()
    }
    if(entityClick instanceof Hunter)
    {
      entityClick.click()
    }
    if(entityClick instanceof Helper)
    {
      entityClick.click()
    }
    if(entityClick instanceof Target)
    {
      entityClick.click()
    }
    if(entityClick instanceof Block)
    {
      entityClick.click()
    }
};

globals.clickOnScreen = function (screenId: number,unityScreenId: UiData){
  const screen = window.PlethoraLib.getInstance().getModel().getEntity(screenId)   
  if (screen instanceof Screen)
  {        
    console.log("UiData = Screen ",unityScreenId) 
    screen.applyClick(unityScreenId)
  }  
};

globals.MeetAction = function (meetObjId: number, objId: number,json: UiData){
  const activatorEntity = window.PlethoraLib.getInstance().getModel().getEntity(meetObjId)   
  if (activatorEntity instanceof Hunter)
  {        
    activatorEntity.applyMeets(objId,json)
  }  
  if (activatorEntity instanceof Helper)
  {        
    activatorEntity.applyMeets(objId,json)
  }  
  if (activatorEntity instanceof Shape)
  {        
    activatorEntity.applyMeets(objId,json)
  }  
  if (activatorEntity instanceof Target)
  {   
    activatorEntity.applyMeets(objId,json)
  }
};

globals.setPlayerDirection = function (playerId: number, value: DataTypeDirection ){
  const player = window.PlethoraLib.getInstance().getModel().getEntity(playerId)   
  if (player instanceof Hunter)
  {      
    player.setDirection(value)
  }  
  if (player instanceof Helper)
  {      
    player.setDirection(value)
  }  
};
globals.destroyTarget = function (targetId: number){
  const target = window.PlethoraLib.getInstance().getModel().getEntity(targetId)   
  if (target instanceof Target)
  {      
    target.delete()
  }  
};
globals.destroyShape = function (shapetId: number){
  const shape = window.PlethoraLib.getInstance().getModel().getEntity(shapetId)   
  if (shape instanceof Shape)
  {      
    shape.delete()
  }  
};






// Use this file to create global functions of your own
// the 'globals' object will be available on the global scope of the program
// it can be later used on Unity jslib like: globals.exampleFunction()
globals.exampleFunction = function () {
  // YOUR CODE HERE
};
